<template>
  <!-- :bodyStyle="{paddingTop:'10px'}" -->
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px',paddingLeft:'24px'}">
    <search-page-view
      ref="table"
      rowKey="id"
      :columns="columns"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="operation">
        <a-input-search placeholder="请输入群发名称" @search="onSearch" style="max-width: 400px;"/>
      </a-form-item>
      <div slot="action" slot-scope="data">
        <a @click="lookEvent(data.record)">查看</a>
      </div>
    </search-page-view>
  </a-card>
</template>

<script>
//versinoName:1,//优惠劵版本 1为基础版 2为标准版 3 高级版
import { mapState } from 'vuex'

export default {
  name: 'GroupSendList',
  data() {
    return {
      submitLoading: false,
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        name: '',
        platformId: this.getPlatformConfig().platformId,
        type: 1
      },
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: 'ID',
          dataIndex: 'id'
        },
        {
          title: '群发名称',
          dataIndex: 'name'
        },
        {
          title: '发送内容',
          dataIndex: 'type'
        },
        {
          title: '发送时间',
          dataIndex: 'time'
        },
        {
          title: '发送状态',
          dataIndex: 'statusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      // 获取版本
      versinoName: state => state.config.serverDataInfo.versinoName
    })
  },
  mounted() {
    this.getTabList()
  },
  methods: {
    getTabList() {
      setTimeout(() => {
        let tabList = []
        if (this.versinoName == '高级版') {
          tabList = [
            { name: 'GroupSentMessage', title: '群发消息' },
            { name: 'GroupSendList', title: '群发记录' },
            { name: 'AutoReplyList', title: '自动回复' }
          ]
        } else {
          tabList = [
            { name: 'GroupSentMessage', title: '群发消息' },
            { name: 'GroupSendList', title: '群发记录' }
          ]
        }
        this.getLogUtils().logWithTag('版本versinoName', this.versinoName)
        this.$store.commit('SET_MENU_HEAD_CONFIG', tabList)
      }, 800)
    },
    onSearch(value) {
      this.queryParams.name = value
      this.$refs.table.refresh(true)
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getServerApiService().post('wxMsg/v2/getList', params)
    },
    lookEvent(data) {
      this.$router.push({
        name: 'GroupSentMessage',
        query: {
          groupId: data.id,
          status: data.status,
          serverId: this.$route.query.serverId,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    }
  }

}
</script>
<style scoped lang="less">

</style>